import * as DictionaryConstants from '../../../../../constants/DictionaryConstants'
import * as ReturnCodesConstants from '../../../../../constants/ReturnCodesConstants'
import * as RoutePathConstants from '../../../../../constants/RoutePathConstants'
import {mapActions, mapState} from 'vuex'
// import dateUtils from '../../../../common/utils/dateUtil'
import moment from 'moment'

export default {
  data () {
    return {
      pageNum: 1,
      pageSize: 10,
      centerHeight: document.documentElement.clientHeight - 210 +'px',
      deleteFlag : false,
      isIndeterminate: false,
      checkAll: false,
      checkedCities: [],
      totalPrice: 0,
      submitFlag: true
    }
  },
  computed: {
    ...mapState('shopptingCartModule', ['shoppingCartList']),
    shoppingCartListInfo () {
      return this.shoppingCartList
    }
  },
  methods: {
    ...mapActions('shopptingCartModule', ['getShoppingCartList','deleteCommodityById']),
    ...mapActions('productOrderModule', ['submitOrder']),
    handleChange (index) {
      if (this.shoppingCartListInfo[index].checked) {
        this.paymentMethod()
      }
    },
    // 验证选中的是否都是统一的支付方式 如果是 计算总价
    paymentMethod () {
      let list = this.shoppingCartListInfo.filter(item => {
        if (item.checked) {
          return item
        }
      })
      this.totalPrice = 0
      let flag = true
      list.some(item => {
        if (item.status === 2000) {
          this.submitFlag = false
          flag = false
          this.$message.warning('存在已失效的商品!')
          return true
        }
        if (list[0].paymentMethod !== item.paymentMethod) {
          this.submitFlag = false
          flag = false
          this.$message.warning('请选择相同支付方式的商品!')
          return true
        }
      })
      if (flag) {
        this.getTotalPrice()
        this.submitFlag = true
      }
    },
    changeType (type) {
      this.deleteFlag = !this.deleteFlag
      if (!this.deleteFlag) {
        this.paymentMethod()
      }
    },
    handleCheckAllChange(val) {
      if (val) {
        this.shoppingCartListInfo.filter(item => {
          item.checked = true
        })
      } else {
        this.shoppingCartListInfo.filter(item => {
          item.checked = false
        })
      }
      this.isIndeterminate = false
      if (!this.deleteFlag) {
        this.paymentMethod()
      }
    },
    checkboxChange() {
      let num = 0
      this.shoppingCartListInfo.filter(item => {
        if (item.checked) {
          num++
        }
      })
      this.checkAll = num === this.shoppingCartListInfo.length
      this.isIndeterminate = num > 0 && num < this.shoppingCartListInfo.length;
      if (!this.deleteFlag) {
        this.paymentMethod()
      }
    },
    getTotalPrice () {
      this.totalPrice = 0
      let list = this.shoppingCartListInfo.filter(item => {
        if (item.checked) {
          return item
        }
      })
      if (list.length === 0) {
        return
      }
      list.filter(item => {
        if (item.paymentMethod === 1000) {
          this.totalPrice += item.commodityStoredValueCard * 1 * item.commodityQty
        } else if (item.paymentMethod === 2000) {
          this.totalPrice += item.commodityPoints * 1 * item.commodityQty
        } else if (item.paymentMethod === 3000) {
          this.totalPrice += item.commodityCash * 1 * item.commodityQty
        }
      })
      if (list[0].paymentMethod === 1000) {
        this.totalPrice += '储值金'
      } else if (list[0].paymentMethod === 2000) {
        this.totalPrice += '积分'
      } else if (list[0].paymentMethod === 3000) {
        this.totalPrice += '元'
      }
    },
    goToMailHomePage () {
      this.$router.push({
        path: RoutePathConstants.POINTS_MAIL_HOME_PAGE
      })
    },
    goToMemberCenter () {
      this.$router.push({
        path: RoutePathConstants.WX_PERSONAL_CENTER
      })
    },
    async submitCommodity () {
      let listId = []
      let list = this.shoppingCartListInfo.filter(item => {
        if (item.checked) {
          listId.push({
            commodityId:item.id,
            commodityQty: item.commodityQty
          })
          return item
        }
      })
      if (list.length === 0) {
        this.$message.warning('请先选择要结算的商品!')
        return
      }
      this.$router.push({
        path: RoutePathConstants.PRODUCT_ORDER,
        query: {
          data: JSON.stringify(list)
        }
      })
    },
    async deleteCommodity () {
      let listId = []
      let listIndex = []
      let list = this.shoppingCartListInfo.filter((item, index) => {
        if (item.checked) {
          listId.push({id:item.shoppingCartId})
          listIndex.push(index)
          return item
        }
      })
      if (list.length === 0) {
        this.$message.warning('请先选择要删除的商品!')
        return
      }
      let res = await this.deleteCommodityById(listId)
      if (res.code === ReturnCodesConstants.SUCCESS_CODE) {
        listIndex.filter((item,index) => {
          this.shoppingCartListInfo.splice(item - index,1)
        })
      } else {
        this.$message.error(`删除失败！`)
      }
    },
    openCommodityDetails (index) {
      this.$router.push({
        path: RoutePathConstants.PRODUCT_DETAILS,
        query: {
          id: this.shoppingCartListInfo[index].id
        }
      })
    },
    dateFormat (time) {
      return time ? moment(time).format('YYYY/MM/DD') : ''
    },
    getShoppingCartListInfo () {
      // let pageData = {
      //   pageNum: this.pageNum,
      //   pageSize: this.pageSize,
      //   commodityType: this.searchInput
      // }
      // this.getCommodityPageList(pageData)
      this.getShoppingCartList()
    },
    load () {
      // this.pageSize += 10
      // this.getShoppingCartListInfo()
    }
  },
  mounted () {
    this.getShoppingCartListInfo()
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/shoppting-cart/views/shoppting-cart.js